var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-google",attrs:{"id":"google-login-btn","disabled":_vm.loading,"variant":"success"},on:{"click":_vm.googleLogin}},[_c('div',{staticClass:"btn-google__icon"},[_c('svg-google')],1),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }